/**
 * Created by roi on 25/07/17.
 */
import { OBTENIR_DATA_HORA_ACTUAL } from '../../src/actions/actionTypes';

const dataActual = (state = '', action) => {
    switch (action.type) {
        case OBTENIR_DATA_HORA_ACTUAL:
            return action.dataHoraActual;
        default:
            return state;
    }

};

export default dataActual;



// WEBPACK FOOTER //
// ./src/reducers/data.js